import CicloService from "@/api/services/cobranza/nomencladores/CicloService"
import Vue from "vue"

const state = () => ({
    ciclo: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    CICLO: state => {
        return state.ciclo
    },
    CICLO_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_CICLO: (state, payload) => {
        state.ciclo = payload
    },

    SET_CICLO_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_CICLO: (state, payload) => {
        state.ciclo.push(payload)
    },

    UPDATE_CICLO: (state, payload) => {
        state.ciclo = state.ciclo.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_CICLO: (state, payload) => {
        state.ciclo = state.ciclo.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_CICLO: async ({ commit, state }, { filter, cicloEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await CicloService.get({ filter, cicloEstado, ...pagination })
            if (status === 200) {
                commit("SET_CICLO", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los ciclos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_CICLO: async ({ commit }) => {
        try {
            let { data, status } = await CicloService.getAll()
            if (status === 200) {
                commit("SET_CICLO", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_CICLO: async ({ commit }) => {
        try {
            let { data, status } = await CicloService.getAllRecords()
            if (status === 200) {
                commit("SET_CICLO", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los ciclos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_CICLO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CicloService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_CICLO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del ciclo, inténtelo nuevamente"
            })
        }
    },

    ADD_CICLO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CicloService.post(payload)
            if (status === 201) {
                commit("ADD_CICLO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El ciclo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el ciclo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_CICLO: async ({ commit }, payload) => {
        try {
            let { data, status } = await CicloService.put(payload)
            if (status === 200) {
                commit("UPDATE_CICLO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El ciclo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el ciclo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_CICLO: async ({ commit }, payload) => {
        try {
            let { status, data } = await CicloService.delete(payload)
            if (status === 204) {
                commit("DELETE_CICLO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El ciclo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_CICLO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El ciclo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el ciclo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
